import { getMeta } from '@helpcenter/meta';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import { HubHomeContentWrapperQuery } from '@atlassian/hub-home';
import type { hubHomeContentWrapperQuery } from '@atlassian/hub-home';

export const EditLayoutResource = createRelayResource<hubHomeContentWrapperQuery>({
    type: 'EDIT_HUB_LAYOUT',
    getQuery: ({ match }, { cloudId }) => {
        const activationId = getMeta('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const computedHelpCenterAri = HelpHelpCenterAri.create({ activationId, helpCenterId }).toString();
        return {
            parameters: HubHomeContentWrapperQuery,
            variables: {
                cloudId,
                hubAri: computedHelpCenterAri,
                hubEditMode: true,
                pageAri: computedHelpCenterAri,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
